import { useState } from 'react';
import CustomSVGs from '../../../ui/customSVGs/CustomSVGs';
import { tickSVG } from '../../../lib/allCustomSVGs';
import MainSquareButton from '../../../ui/buttons/MainSquareButton';
import { useTranslation } from 'react-i18next';
import { AnimatePresence, motion } from 'framer-motion';
import make_package_subscriptions_api_call from '../../../lib/api/ai-tracker/subscriptions/make_package_subscriptions_api_call';
import { useDispatch } from 'react-redux';
import { setIsPaymentPopupOpen } from '../../../store/reducers/uiSlice';
import getCurrencySymbol from '../../../lib/helper-functions/getCurrencySymbol';
import manage_package_subscriptions_api_call from '../../../lib/api/ai-tracker/subscriptions/manage_package_subscriptions_api_call';
import { setTaraSubscriptionDetails } from '../../../store/reducers/userSlice';

type Props = {
  isMonthly: boolean;
  packageDetails: {
    id: number;
    name: string;
    annual_slug: string;
    monthly_slug: string;
    monthly_price: string;
    annual_price: string;
    monthly_price_number: number;
    annual_price_number: number;
    description: string;
    features: string[];
    is_most_popular: boolean;
    currency: string;
    subscription_id?: number;
    next_billing_date?: string;
    is_active?: boolean;
  };
  isCancelMode?: boolean;
  isUpgradable?: boolean;
  setIsSupportPopupOpen?: (value: boolean) => void;
};

const SellerPackageItem = ({
  isMonthly,
  packageDetails,
  isCancelMode = false,
  isUpgradable = false,
  setIsSupportPopupOpen,
}: Props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [loading, setLoading] = useState<'pending' | 'initial'>('initial');

  const onMakeSubscription = async () => {
    setLoading('pending');
    try {
      const res = await make_package_subscriptions_api_call(
        isMonthly ? packageDetails.monthly_slug : packageDetails.annual_slug
      );

      if (res) {
        setLoading('initial');
        dispatch(setIsPaymentPopupOpen(false));
        if (
          res?.payment_details?.payment_details?._links?.checkout?.href &&
          typeof res?.payment_details?.payment_details?._links?.checkout
            ?.href === 'string'
        ) {
          window.location.href =
            res?.payment_details?.payment_details?._links?.checkout?.href;
        }
      } else {
        setLoading('initial');
        dispatch(setIsPaymentPopupOpen(false));
      }
    } catch (error) {
      console.error('Error making subscriptions:', error);
      setLoading('initial');
      dispatch(setIsPaymentPopupOpen(false));
    }
  };

  const onManageSubscription = async () => {
    setLoading('pending');
    try {
      const res = await manage_package_subscriptions_api_call(
        packageDetails?.subscription_id ?? 0
      );
      if (res) {
        setLoading('initial');
        // dispatch(
        //   setTaraSubscriptionDetails({ currentSubscriptionStatus: 'none' })
        // );
        if (
          res?.data?.portal_url &&
          typeof res?.data?.portal_url === 'string'
        ) {
          window.location.href = res?.data?.portal_url;
        }
      } else {
        setLoading('initial');
      }
    } catch (error) {
      console.error('Error cancelling subscriptions:', error);
      setLoading('initial');
    }
  };

  // const onSupportSubmitHandler = async () => {
  //   setLoading('pending');

  //   try {
  //     const sendingData = JSON.stringify({
  //       type: 'subscription',
  //       data: {
  //         // cms_url: shopURL,
  //         shop_slug: shopSlug,
  //       },
  //     });

  //     const requestInfo: RequestInfo = {
  //       url: HELP_LINE_API,
  //       method: 'POST',
  //       body: sendingData,
  //       headers: {
  //         Accept: 'application/json',
  //         'Content-type': 'application/json',
  //         Authorization: accessToken.type + ' ' + sellerToken,
  //       },
  //     };

  //     const actionType = 'HELP_LINE_API_POST';
  //     const customMsg = t('EmailSentSuccessfully');

  //     const res: any = await asyncHandler(requestInfo, actionType, customMsg);

  //     const response = res.data;
  //     if (res.actionType === actionType && response.success) {
  //       setIsSupportPopupOpen(true);
  //       setLoading('initial');
  //     } else {
  //       setLoading('initial');
  //     }
  //   } catch (exception) {
  //     setLoading('initial');
  //     console.log('Error during authentication request');
  //     submitLogToBugsnag('error', `${exception}`);
  //   }
  // };

  // const onSubmitHandler = async () => {
  //   if (
  //     packageDetails.annual_slug === 'company-annually' ||
  //     packageDetails.annual_slug === 'company-monthly'
  //   ) {
  //     onSupportSubmitHandler();
  //   } else {
  //     onMakeSubscription();
  //   }
  // };

  return (
    <div
      data-is-most-popular={packageDetails.is_most_popular?.toString()}
      data-is-active-subscription={
        packageDetails.is_active?.toString() ?? 'false'
      }
      className='sellerPackageItem'
      data-is-disabled={(
        isCancelMode &&
        !packageDetails.is_active &&
        !isUpgradable
      ).toString()}
    >
      {packageDetails.is_most_popular && (
        <div className='sellerPackageItem__badge'>{t('MostPopular')}</div>
      )}
      {isCancelMode && packageDetails.is_active && (
        <div
          data-is-active-subscription={
            packageDetails.is_active?.toString() ?? 'false'
          }
          className='sellerPackageItem__badge'
        >
          {t('Active')}
        </div>
      )}

      <div className='sellerPackageItem-content'>
        <h2 className='sellerPackageItem__title'>
          {packageDetails.name + ' ' + (!isMonthly ? '(Annual)' : '')}
        </h2>

        {isCancelMode &&
          packageDetails.is_active &&
          packageDetails.next_billing_date && (
            <div className='sellerPackageItem__billing-date collapseList__item--top-left-tag collapseList__item--top-left-tag-yellow'>
              {t('NextBillingDate')}:{' '}
              <b> {packageDetails.next_billing_date?.split(' ')[0]}</b>
            </div>
          )}

        <div
          className='sellerPackageItem__prices'
          style={
            isCancelMode && !packageDetails.is_active
              ? { marginTop: '4.2rem' }
              : {}
          }
        >
          <AnimatePresence exitBeforeEnter>
            {isMonthly && (
              <motion.div
                key={isMonthly.toString()}
                initial={{ opacity: 0.1 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0.1 }}
                transition={{ duration: 0.3 }}
                className='sellerPackageItem__prices--monthly'
              >
                <h2>{packageDetails.monthly_price}</h2>
                <p>{t('/month')}</p>
              </motion.div>
            )}
            {!isMonthly && (
              <motion.div
                key={isMonthly.toString()}
                initial={{ opacity: 0.1 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0.1 }}
                transition={{ duration: 0.3 }}
                className='sellerPackageItem__prices--annual'
              >
                <h3>{`${getCurrencySymbol(packageDetails.currency)}${
                  packageDetails.monthly_price_number * 12
                }`}</h3>
                <h2>{packageDetails.annual_price}</h2>
                <p>{isMonthly ? t('/month') : t('/year')}</p>
              </motion.div>
            )}
          </AnimatePresence>
        </div>
        <p className='sellerPackageItem__description'>
          {packageDetails.description}
        </p>
        <div className='sellerPackageItem__features'>
          {packageDetails.features.map((feature, index) => (
            <div key={index} className='sellerPackageItem__features--item'>
              <div className='sellerPackageItem__features--item-icon'>
                <CustomSVGs svg={tickSVG} />
              </div>
              <div className='sellerPackageItem__features--item-text'>
                {feature}
              </div>
            </div>
          ))}
        </div>
      </div>
      {!isCancelMode && (
        <div className='sellerPackageItem__button'>
          <MainSquareButton
            onClick={(e) => {
              e.preventDefault();
              onMakeSubscription();
            }}
            type={'button'}
            disabled={loading === 'pending'}
            value={loading === 'pending' ? t('Loading') : t('GetStarted')}
            normal={true}
          />
        </div>
      )}
      {isCancelMode && packageDetails.is_active && (
        <div className='sellerPackageItem__button'>
          <MainSquareButton
            onClick={(e) => {
              e.preventDefault();
              onManageSubscription();
            }}
            type={'button'}
            disabled={loading === 'pending'}
            value={
              loading === 'pending' ? t('Loading') : t('ManageSubscription')
            }
            normal={true}
          />
        </div>
      )}

      {isCancelMode && isUpgradable && (
        <div className='sellerPackageItem__button'>
          <MainSquareButton
            onClick={(e) => {
              e.preventDefault();
              onMakeSubscription();
            }}
            type={'button'}
            disabled={loading === 'pending'}
            value={
              loading === 'pending' ? t('Loading') : t('UpgradeSubscription')
            }
            normal={true}
          />
        </div>
      )}
    </div>
  );
};

export default SellerPackageItem;
